import React from 'react';
import { Menu, Image, Header, Button } from 'semantic-ui-react';
import { shape, func } from 'prop-types';

import AudioPlayer from './AudioPlayer';

const StationPlayer = ({ station, closePlayer, player, setPlayer }) => {
  const playerOptions = {
    autoplay: true,
    controls: true,
    controlBar: {
      fullscreenToggle: false,
      remainingTimeDisplay: false,
      progressControl: false
    },
    sources: station.streams
  };
  return (
    <Menu fixed="bottom" id="station-player">
      <Menu.Item>
        <Image
          size="tiny"
          src={`https://www.twr360.org/images/sized/${
            station.logo
          }/c250x250/thumb.jpg?p=files/library`}
        />
      </Menu.Item>
      <Menu.Item>
        <Header>{station.name}</Header>
      </Menu.Item>
      <Menu.Item fitted="horizontally">
        <AudioPlayer
          {...playerOptions}
          playerObject={player}
          setPlayer={setPlayer}
        />
      </Menu.Item>
      <Menu.Item position="right">
        <Button icon="close" onClick={() => closePlayer()} />
      </Menu.Item>
    </Menu>
  );
};

StationPlayer.propTypes = {
  station: shape().isRequired,
  closePlayer: func.isRequired,
  player: shape().isRequired,
  setPlayer: func.isRequired
};

export default StationPlayer;
